<template>
  <v-container
    grid-list-md
    text-xs-center
  >
    <v-flex
      xs8
      offset-xs2
    >
      <v-alert
        v-if='offlineMessage'
        :value="true"
        type="info"
      >
        Some Hardware details are missing due to manual entry
      </v-alert>
    </v-flex>

    <v-layout
      row
      v-if='assetDetail'
    >

      <v-flex
        d-flex
        xs12
        sm4
        md2
      >
        <v-card class='mt-5'>
          <v-toolbar
            color="secondary"
            dark
          >
            <v-toolbar-title>Status</v-toolbar-title>
            <v-spacer></v-spacer>

          </v-toolbar>
          <v-card-text v-if='assetLotDetail'>
            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title><span class='font-weight-bold'>Created Date</span></v-list-tile-title>
                <v-list-tile-sub-title>{{assetLotDetail.createdDate}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title><span class='font-weight-bold'>Customer</span></v-list-tile-title>
                <v-list-tile-sub-title>{{assetLotDetail.client}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title><span class='font-weight-bold'>Location Name:</span></v-list-tile-title>
                <v-list-tile-sub-title v-if='locationDetail'>{{locationDetail.name}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title><span class='font-weight-bold'>Lot</span></v-list-tile-title>
                <v-list-tile-sub-title>{{assetLotDetail.lotNumber}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-card-text>
        </v-card>
      </v-flex>
      <MonitorDetail
        v-if='assetDetail.AssetType==="monitor"'
        :assetDetail='assetDetail'
      />
      <ComputerDetail
        v-if='assetDetail.AssetType==="computer"'
        :assetDetail='assetDetail'
      />
      <PhoneDetail
        v-if='assetDetail.AssetType==="phone"'
        :assetDetail='assetDetail'
      />

      <v-flex
        d-flex
        xs12
        sm6
        md3
      >
        <v-layout
          row
          wrap
        >

          <v-flex d-flex>
            <v-layout
              row
              wrap
            >
              <v-flex
                d-flex
                xs12
              >
                <v-card
                  class='mt-5'
                  v-if='assetDetail'
                >
                  <v-toolbar
                    color="secondary"
                    dark
                  >
                    <v-toolbar-title>Snapshots</v-toolbar-title>
                    <v-spacer></v-spacer>

                  </v-toolbar>

                  <v-expansion-panel>
                    <v-expansion-panel-content
                      v-for="(item,i) in snapshots"
                      :key="i"
                    >
                      <template v-slot:header>
                        <div>{{item.Time}}</div>
                      </template>
                      <v-card>
                        <v-card-text>
                          <div
                            v-for="(item,i) in item.diff"
                            :key="i"
                          >
                            <Snapshotitem :snapshotevent='item' />
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                </v-card>
              </v-flex>
              <v-flex
                d-flex
                xs12
              >
                <v-card
                  class='mt-5'
                  v-if='assetDetail'
                >
                  <v-toolbar
                    color="secondary"
                    dark
                  >
                    <v-toolbar-title>Photos</v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                    <input
                    type='file'
                    accept="image/*"
                    @change="uploadImage"
                    />
                <template>
  
  
        <v-container grid-list-sm fluid>
          <v-layout row wrap>
            <v-flex
              v-for="(n,index) in photos"
              :key="index"
              xs4
              d-flex
            >
              <v-card :href='n' target='_blank' flat tile class="d-flex">
                <v-img

                  :src="n"
                
                  aspect-ratio="1"
                  class="grey lighten-2"
                >
                 
                </v-img>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
</template>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-dialog
        v-model="loadingDialog"
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            Uploading data.....
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
import config from "../firebaseIDs"
import Snapshotitem from '../components/SnapShotItem'
import MonitorDetail from '../components/MonitorDetail.vue'
import ComputerDetail from '../components/ComputerDetail'
import PhoneDetail from '../components/PhoneDetail'
import { mapFields } from 'vuex-map-fields';
const fb = require('../firebaseConfig.js')
const odiff = require('odiff')

export default {
  name: 'assets',
  components: {
    MonitorDetail,
    ComputerDetail,
    PhoneDetail,
    Snapshotitem
  },
  data () {
    return {
      locationDetail: null,
      assetLotDetail: null,
      offlineMessage: false,
      snapshots: [],
      snapshotsDiff: [],
      magentoDialog: false,
      photos : [],
      loadingDialog: false,
      preview: null,
      Printdialog: false,
      locationsArr: [],
      dialog: false,
      assetDetail: null,
      auditHistory: []
    }
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },
  methods: {
          uploadImage(e){
        var storageRef = fb.storage.ref();
        var logoRef = storageRef.child('images/'+this.$route.params.id+"/"+e.target.files[0].name)
        logoRef.put(e.target.files[0]).then((snapshot)=> {
                  fb.AssetsCollections.doc(this.$route.params.id).update({
            Images: fb.firestore.FieldValue.arrayUnion("gs://"+ config.config.storageBucket + '/images/'+this.$route.params.id+"/"+e.target.files[0].name)
        })
        //save gs ref to settings collections
});
      },

    goTo () {
      this.$router.push('/location/' + this.assetDetail.Discovery.location)
    },

    googleCloudImageFetcher(){
      this.photos = [];
      if(this.assetDetail.Images){
              this.assetDetail.Images.forEach(image => {
           var gsReference = fb.storage.refFromURL(image)
           gsReference.getDownloadURL().then((url)=> {
              this.photos.push(url);
           })
      })
         
      }

            
    },
    fetchData () {
      fb.LocationsCollections.where("assets", "array-contains", parseInt(this.$route.params.id)).get().then(d => {
        d.forEach((doc) => {
          this.locationDetail = doc.data()
        })
      })
      fb.LotsCollections.where("Assets", "array-contains", parseInt(this.$route.params.id)).get().then(d => {
        d.forEach((doc) => {
          this.assetLotDetail = doc.data()
        })
      })
      fb.SnapShotCollections.where("Discovery.AssetTag", "==", this.$route.params.id).orderBy("Time", "desc").onSnapshot(d => {
        this.snapshots = []
        d.forEach((doc) => {
          this.snapshots.push(doc.data())
        })


        for (var i = 0; i < this.snapshots.length; i++) {
          if (i !== this.snapshots.length) {
            var diffs = odiff(this.snapshots[i], this.snapshots[i + 1])
            this.snapshots[i].diff = diffs

          }
        }
      })

      fb.AssetsCollections.doc(this.$route.params.id).onSnapshot(doc => {
        if (doc.exists) {
          switch (doc.data().AssetType) {
            case "computer":
              this.assetDetail = doc.data()
              this.googleCloudImageFetcher()
              this.assetDetail.Discovery.Mode !== "online" ? this.offlineMessage = true : this.offlineMessage = false
              if (!this.assetDetail.Discovery.GraphCardsInfo) {
                this.assetDetail.Discovery.GraphCardsInfo = [{
                  GraphicCardName: "",
                  PNPDeviceID: ""
                }]
              } else if (this.assetDetail.Discovery.GraphCardsInfo.length === 0) {
                this.assetDetail.Discovery.GraphCardsInfo.push({
                  GraphicCardName: "",
                  PNPDeviceID: ""
                })
              }
              break;
            case "monitor":
              this.assetDetail = doc.data()
              break;
            default:
              this.assetDetail = doc.data()
              break;
          }
        }
      })
      fb.SnapShotCollections.where("Discovery.AssetTag", "==", this.$route.params.id).onSnapshot(docs => {
        this.auditHistory = []
        docs.forEach((doc) => {
          this.auditHistory.push(doc.data())
        })
      })
    }

  },
  computed: {
    ...mapFields([
      'imageURL', "snackBarMessage",
      "snackBar", "snackBarcolor"
    ]),
  },
  mounted () {
    this.fetchData()



  },
}
</script>

